import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { LocalStorageEnum } from '../../enums/token.enum';
import { IStates } from 'src/app/shared/models/selfcare-flows-views.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {
  private readonly _unsubscribe$ = new Subject<boolean>();

  setLocalStorageAccessToken(loginResponse: string): void {
    localStorage.setItem(LocalStorageEnum.TOKEN, loginResponse);
  }

  getLocalStorageAccessToken(): string {
    return localStorage.getItem(LocalStorageEnum.TOKEN) || '';
  }

  setLocalStorageUserType(param: string): void {
    localStorage.setItem(LocalStorageEnum.USER_TYPE, param);
  }

  getLocalStorageUserType(): string {
    return localStorage.getItem(LocalStorageEnum.USER_TYPE) || '';
  }

  setLocalStorageFlow(param: string): void {
    localStorage.setItem(LocalStorageEnum.FLOW, param);
  }

  getLocalStorageFlow(): string {
    return localStorage.getItem(LocalStorageEnum.FLOW) || '';
  }
  setLocalStorageSinisterIdEc(param: string): void {
    localStorage.setItem(LocalStorageEnum.SINISTER_ID_EC, param);
  }

  getLocalStorageSinisterIdEc(): string {
    return localStorage.getItem(LocalStorageEnum.SINISTER_ID_EC) || '';
  }

  setLocalStorageSinisterId(param: string): void {
    localStorage.setItem(LocalStorageEnum.SINISTER_ID, param);
  }

  getLocalStorageSinisterId(): string {
    return localStorage.getItem(LocalStorageEnum.SINISTER_ID) || '';
  }

  setLocalStorageFormId(param: string): void {
    localStorage.setItem(LocalStorageEnum.FORM_ID, param);
  }

  getLocalStorageFormId(): string {
    return localStorage.getItem(LocalStorageEnum.FORM_ID) || '';
  }

  setLocalStorageLanguage(userLanguage: string): void {
    localStorage.setItem(LocalStorageEnum.LANGUAGE, userLanguage);
  }

  getLocalStorageLanguage(): string {
    return localStorage.getItem(LocalStorageEnum.LANGUAGE)!;
  }

  setLocalStorageNextState(nextState: string): void {
    localStorage.setItem(LocalStorageEnum.NEXT_STATE, nextState);
  }

  getLocalStorageNextState(): string {
    return localStorage.getItem(LocalStorageEnum.NEXT_STATE)!;
  }

  setLocalStorageState(state: IStates): void {
    const jsonString = JSON.stringify(state);
    localStorage.setItem(LocalStorageEnum.STATE, jsonString);
  }

  getLocalStorageState(): IStates | null {
    const jsonString = localStorage.getItem(LocalStorageEnum.STATE);
    if (jsonString) {
      return JSON.parse(jsonString);
    }
    return null;
  }

  setLocalStorageFnolIsRunning(fnol: string): void {
    localStorage.setItem(LocalStorageEnum.FNOL, fnol);
  }

  getLocalStorageFnolIsRunning(): string {
    return localStorage.getItem(LocalStorageEnum.FNOL) || '';
  }
  setLocalStorageFnolIsStarting(fnol: string): void {
    localStorage.setItem(LocalStorageEnum.FNOL_START, fnol);
  }

  getLocalStorageFnolIsStarting(): string {
    return localStorage.getItem(LocalStorageEnum.FNOL_START) || '';
  }

  setLocalStorageNeedToAddMobilierForm(mobilier: string): void {
    localStorage.setItem(LocalStorageEnum.MOBILIER, mobilier);
  }

  getLocalStorageNeedToAddMobilierForm(): string {
    return localStorage.getItem(LocalStorageEnum.MOBILIER) || '';
  }

  setLocalStorageNeedToAskSummaryMobilier(mobilier: string): void {
    localStorage.setItem(LocalStorageEnum.SUMMARY_MOBILIER, mobilier);
  }

  getLocalStorageNeedToAskSummaryMobilier(): string {
    return localStorage.getItem(LocalStorageEnum.SUMMARY_MOBILIER) || '';
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(true);
    this._unsubscribe$.complete();
  }
}
